import { personalInvoicesRequest } from '@/services'
import { Notify } from 'vant'
import { deepCopy, isSameByInvoiceCode } from '@utils/basicUtil'
export default {
  namespaced: true,
  state: {
    cardList: [],
    total: '',
    checkedAll: false
  },
  mutations: {
    setCardList (state, cardList) {
      state.cardList = cardList
    },
    setTotal (state, total) {
      state.total = total
    },
    setCheckedAll (state, checkedAll) {
      state.checkedAll = checkedAll
    }
  },
  actions: {
    async initGardList ({ commit }) {
      await commit('setCardList', [])
    },
    async getCardList ({ commit, state }, query) {
      const cardList = state.cardList
      const data = await personalInvoicesRequest.personalInvoices.cardList(query)
      if (data.success) {
        // 查看是否需要手动关闭取消全选
        if (data.result.records && Array.isArray(data.result.records)) {
          if (data.result.records.find(i => Number(i.reimbursementFlag) === 0 && i.invoiceSource !== 1)) {
            await commit('setCheckedAll', false)
          }
        }
        // 这里查看是否存在缓存勾选的票，如果存在把那一条的状态flag勾选状态，拿过来
        const selCardList = sessionStorage.selCardList ? JSON.parse(sessionStorage.selCardList) : []
        const newCardData = cardList.concat(data.result.records)
        // 记录当前数据中，有多少被勾选上了，用来与当前数据可勾选数量对比
        // sessionStorage.oldSelCardList 如果这个缓存存在，标示是从修改过来的，可勾选数量以及勾选数量初始化成这个的长度
        let selectLength = 0
        let sureSelectLength = sessionStorage.oldSelCardList ? JSON.parse(sessionStorage.oldSelCardList).length : 0
        // checkItem 存在的都是之前被勾选过的
        selCardList.forEach(checkItem => {
          newCardData.map(i => {
            // 根据缓存中数据的id，匹配新查询回来的数据id，如果相同就勾选起来
            if (isSameByInvoiceCode(checkItem, i)) {
              i.flag = true
              selectLength += 1
            }
            return i
          })
        })
        newCardData.forEach(i => {
          if (Number(i.reimbursementFlag) === 0 && i.invoiceSource !== 1) {
            sureSelectLength += 1
          }
        })
        // 说明勾选的数据在目前所有数据里都找到了
        if (sureSelectLength !== 0 && selectLength !== 0 && selectLength === sureSelectLength) {
          await commit('setCheckedAll', true)
        }
        await commit('setCardList', newCardData)
        await commit('setTotal', data.result.total)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async editCheckedAll ({ commit }, value) {
      await commit('setCheckedAll', value)
    },
    async selectAll ({ commit, state }) {
      let cardList = state.cardList
      let value = state.checkedAll
      let oldSelCardList = sessionStorage.oldSelCardList ? JSON.parse(sessionStorage.oldSelCardList) : []
      const selCardList = []
      cardList.map(i => {
        // 如果满足勾选权限，就将他注入到selCardList中
        if (value && ((Number(i.reimbursementFlag) === 0 && i.invoiceSource !== 1) || oldSelCardList.find(oldI => isSameByInvoiceCode(oldI, i)))) {
          selCardList.push(i)
        }
        if (value && ((Number(i.reimbursementFlag) === 0 && i.invoiceSource !== 1) || oldSelCardList.find(oldI => isSameByInvoiceCode(oldI, i)))) {
          i.flag = true
        } else {
          i.flag = false
        }
        return i
      })
      if (!value) {
        sessionStorage.selCardList = JSON.stringify([])
      } else {
        sessionStorage.selCardList = JSON.stringify(selCardList)
      }
      sessionStorage.cardList = JSON.stringify(cardList)
      await commit('setCardList', deepCopy(cardList))
    }
  }
}
